export default __webpack_public_path__ + "static/FuturaBT-Medium-4e921970cd819f7016e3e12c04e6d217.woff";